// @flow

type Options = { silenceInTest?: boolean, useWarning?: boolean };

const logError = (error: ?Error, options?: Options) => {
  if (
    error &&
    // Silence logging in tests
    (process.env.NODE_ENV !== 'test' || options?.silenceInTest === false)
  ) {
    if (options?.useWarning === true) {
      console.warn(error);
    } else {
      console.error(error);
    }
  }
};

export default logError;
